import { getPharmacyById } from '@lotushealth/lotushealth_js_sdk/endpoints';
import { lotusHealthZod } from '@lotushealth/lotushealth_js_sdk';
import type { PharmacyT } from '@lotushealth/lotushealth_js_sdk/schemas';

import { createLotusRequestConfig } from '@/shared/api/lotus';

export async function fetchPharmacyById(
  pharmacyId: string,
  signal?: AbortSignal
): Promise<PharmacyT> {
  const config = await createLotusRequestConfig({ signal });
  const response = await getPharmacyById(pharmacyId, config);
  return lotusHealthZod.getPharmacyByIdResponse.parse(response.data) as PharmacyT;
}
